<template>
    <button :class="['simple_button', { 'disabled_button': disabled },
        { 'empty_classification_button': clasificar },
        classification ? [getButtonStyle(classiValue), 'classi_button', skew(classiValue)] : '']"
        :style="computedStyle" @click="onButtonClick()">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: "SimpleButton",
    data() {
        return {
            buttonStyles: ['b-red', 'b-blue', 'b-yellow', 'b-green', 'b-brown', 'b-orange', 'b-pink'],
            skew_styles: ['skew_box_1', 'skew_box_2', 'skew_box_3', 'skew_box_4', 'skew_box_5'],
        };
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        buttonStyle: {
            type: String,
            default: '',
        },
        clasificar: {
            type: Boolean,
            default: false,
        },
        classiValue: {
            type: String,
            default: '',
        },
    },
    computed: {
        computedStyle() {
            return !this.disabled ? { backgroundImage: this.buttonStyle } : {};
        },
        classification() {
            return this.classiValue != '';
        }
    },
    methods: {
        getNumberFromName(name, list) {
            const asciiSum = name.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
            const styleIndex = asciiSum % list.length;
            return styleIndex;
        },
        getButtonStyle(name) {
            const styleIndex = this.getNumberFromName(name, this.buttonStyles);
            return this.buttonStyles[styleIndex];
        },
        skew(name) {
            const styleIndex = this.getNumberFromName(name, this.skew_styles);
            return this.skew_styles[styleIndex];

        },
        onButtonClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('click');
        },
    },
};
</script>
<style lang="scss" scoped>
$disabled_button_color: #ddd;
$button_color: #c0c0c038;

.disabled_button {
    background-color: $disabled_button_color !important;
    padding: 0 2px;
    border-radius: 1px;
    font-weight: bold;
    filter: drop-shadow(-1px 1px 2px #d0d0d099);
    border-width: 1px;
    border-bottom-width: 4px;
    border-style: solid;
    border-color: #000000ff;
    pointer-events: none;
}

.simple_button {
    position: relative;
    cursor: pointer;
    border-width: 1px;
    border-style: solid;
    border-color: #c0c0c038;
    border-radius: 1px;
    padding: 0 2px;
    margin: 1px 0 1px 0;
    font-weight: bold;
    background-color: $button_color;
    overflow-y: hidden;
    transition: background-color 0.07s, transform 0.07s, filter 0.07s;

    &:hover {
        position: relative;
        background-color: inherit;
        transform: translateY(0); // Keep button in place on hover
        border-top-color: #ebebeb;
        border-left-color: #ebebeb;
        border-right-color: #50505088;
        border-bottom-width: 1px;
        border-bottom-color: #50505099;
        background-color: $button_color;
        filter: brightness(1.1);
    }
}

.simple_button:hover {
    padding-top: 0px;
    padding-bottom: 3px;
    filter: brightness(1.2);
    transform: translateY(-1px);
    filter: drop-shadow(2px 2px 4px rgb(181, 181, 181));
}

.simple_button:active {
    background-color: #ccccff99;
    transform: translateY(1px);
}

.empty_classification_button {
    border-radius: 2px !important;
    padding: 0 2px 0 2px !important;
    border: 3px outset #f66 !important;
}

.classi_button {
    flex: 0 1 auto;
    white-space: nowrap;
    font-weight: 100 !important;
    padding: 1px 4px 1px 4px !important;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        padding-top: 0px;
        padding-bottom: 1px;
        filter: brightness(1.05);
        font-weight: 100 !important;
    }
}

.b-red {
    color: black;
    border-right: 3px solid rgb(248, 175, 175) !important;
    border-bottom: 3px solid rgb(199, 136, 136) !important;
    background-color: #eeeeee !important;
}

.b-blue {
    color: black;
    border-right: 3px solid rgb(181, 181, 254) !important;
    border-bottom: 3px solid rgb(145, 145, 204) !important;
    background-color: #eeeeee !important;
}

.b-green {
    color: black;
    border-right: 3px solid rgb(100, 255, 100) !important;
    border-bottom: 3px solid rgb(82, 219, 82) !important;
    background-color: #eeeeee !important;
}

.b-brown {
    color: black;
    border-right: 3px solid rgb(227, 155, 165) !important;
    border-bottom: 3px solid rgb(199, 132, 141) !important;
    background-color: #eeeeee !important;
}

.b-orange {
    color: black;
    border-right: 3px solid rgb(254, 211, 130) !important;
    border-bottom: 3px solid rgb(221, 183, 111) !important;
    background-color: #eeeeee !important;
}

.b-yellow {
    color: black;
    border-right: 3px solid rgb(249, 249, 164) !important;
    border-bottom: 3px solid rgb(219, 219, 148) !important;
    background-color: #eeeeee !important;
}

.b-pink {
    color: black;
    border-right: 3px solid pink !important;
    border-bottom: 3px solid rgb(204, 149, 158) !important;
    background-color: #eeeeee !important;
}
</style>